<template>
  <div class="version-view-box">
    <div class="engine-box">
      <Engine ref="engine" />
    </div>
    <DragPanel
      class="version-tree-panel"
      title="目录树"
      :closePanel="closeViewTreePanel"
      v-show="isViewTreePanelVisible">
      <BimElemTree
        v-if="bimElemTreeRootData.length"
        ref="bimElemTree"
        :isShareDataSet="false"
        :dataSetId="dataSetId"
        :version="version"
        :isShowRvtGroup="isShowRvtGroup"
        :bimElemTreeRootData="bimElemTreeRootData" />
      <div
        class="bottom-option-box"
        v-if="isOptionVisible">
        <el-checkbox
          class="checkbox-primary"
          v-model="isShowRvtGroup">
          Group目录树
        </el-checkbox>
      </div>
    </DragPanel>
    <AttributePanel
      v-show="isAttributePanelVisible"
      :isRvtGroupMode="isShowRvtGroup"
      :isElemExist="isElemExist"
      :attributeData="attributeData"
      :closePanel="closeAttributePanel" />
  </div>
</template>

<script>
import DragPanel from '@/components/CustomDragPanel.vue'
import BimElemTree from './components/BimElemTree.vue'
import AttributePanel from '@/components/AttributePanel.vue'
import Engine from './components/VersionCompareEngine.vue'

import { highLightElems } from '@/utils/engineUtils'

import {
  getProjectTree,
  getDataSetResService,
  getProjectParam,
  getRvtGroupByElemIdService,
  getRvtGroupAttrService,
  getBimElemIdsByGroupService
} from '@/service/interface'

export default {
  data() {
    return {
      isViewTreePanelVisible: false,

      dataSetId: '',
      version: '',
      bimElemTreeRootData: [],
      isShowRvtGroup: false,

      isAttributePanelVisible: false,
      elemInfo: {},
      attributeData: []
    }
  },
  components: {
    AttributePanel,
    Engine,
    DragPanel,
    BimElemTree
  },
  computed: {
    isOptionVisible: function () {
      const rootNode = this.bimElemTreeRootData[0]
      let visible = false
      if (this.formatType === 1) {
        visible = rootNode?.hasRvtGroup
      } else {
        const files = rootNode ? rootNode.files : []
        visible = files.some(el => el.hasRvtGroup)
      }

      return visible
    },
    isElemExist() {
      return Object.keys(this.elemInfo).length ? true : false
    }
  },
  mounted() {
    this.initCatalogTree()

    this.$eventManage.on('engineCreated', this.onEngineCreated)
    this.$eventManage.on('dataSetLoadFinish', this.onDataSetLoadFinish)
    this.$eventManage.on('themeChange', this.onUIThemeChange)
    this.$eventManage.on('customBtnClick', this.onCustomBtnClick)
    this.$eventManage.on('selElement', this.handleModelClick)
  },
  beforeDestroy() {
    this.$eventManage.off('engineCreated', this.onEngineCreated)
    this.$eventManage.off('dataSetLoadFinish', this.onDataSetLoadFinish)
    this.$eventManage.off('themeChange', this.onUIThemeChange)
    this.$eventManage.off('customBtnClick', this.onCustomBtnClick)
    this.$eventManage.off('selElement', this.handleModelClick)
  },
  beforeRouteLeave(to, from, next) {
    this.removeCustomBtn()
    this.copyCanvas()
    next()
  },
  methods: {
    initCatalogTree() {
      return new Promise(resolve => {
        let { dataSetId, versionId } = this.$route.query
        this.dataSetId = dataSetId
        this.version = versionId
        let params = { dataSetId, version: versionId }
        getProjectTree(params).then(response => {
          if (response.isSuccess) {
            let dataSets = response.data

            let formatType = dataSets[0].formatType
            this.formatType = formatType

            let treeData = this.formatDataSetData(dataSets)
            this.bimElemTreeRootData = treeData
            resolve()
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    onEngineCreated() {
      this.getDatasetResource().then(dataSets => {
        let domRef = this.$refs.engine

        domRef.loadDataSetByVersion(dataSets)
      })
    },
    onDataSetLoadFinish() {
      this.isViewTreePanelVisible = true

      this.addCustomBtn()
    },
    async handleModelClick(eventInfo) {
      let elemInfo = eventInfo.elemInfo
      let elemIds = window.BlackHole3D.BIM.getSelElemIDs()
      if (!elemIds.length || elemInfo.elemType !== 'BIMElem') {
        this.elemInfo = {}
        this.attributeData = []
        return
      }

      this.elemInfo = elemInfo
      if (this.isShowRvtGroup) {
        const rvtGroupInfo = await this.getRvtGroupInfo()
        this.highLightGroupElems(rvtGroupInfo)

        if (this.isAttributePanelVisible) {
          const attributeData = await this.getRvtGroupAttr(rvtGroupInfo)
          this.attributeData = attributeData
        }
      } else {
        if (this.isAttributePanelVisible) {
          this.queryBIMElemAttr()
        }
      }
    },
    async getRvtGroupInfo() {
      const { dataSetId, versionId } = this.$route.query
      const elemIntId = this.elemInfo.elemId
      const params = { dataSetId, elemIntId, version: versionId }
      const response = await getRvtGroupByElemIdService(params)
      if (response.isSuccess) {
        return response.data
      } else {
        this.$message.error(response.errMsg)
      }
    },
    async queryBIMElemAttr() {
      let { dataSetId, versionId } = this.$route.query
      let elementId = this.elemInfo.elemId
      let params = {
        dataSetId,
        elementIntId: elementId,
        version: versionId,
        isQueryExtend: false
      }
      getProjectParam(params).then(response => {
        if (response.isSuccess) {
          let data = response.data
          let attributeData = data.elementParamGroups
          this.attributeData = attributeData
        } else {
          this.isAttributePanelVisible = false
          this.attributeData = []
          this.$message.error(response.errMsg)
        }
      })
    },
    async getRvtGroupAttr(rvtGroupInfo) {
      if (!rvtGroupInfo) {
        return []
      }

      const { dataSetId, versionId } = this.$route.query
      const groupIntId = rvtGroupInfo.groupIntId
      const params = { dataSetId, groupIntId, version: versionId }
      const response = await getRvtGroupAttrService(params)
      if (response.isSuccess) {
        const data = response.data
        return data.params
      } else {
        this.$message.error(response.errMsg)
        return []
      }
    },
    async highLightGroupElems(rvtGroupInfo) {
      if (!rvtGroupInfo) return

      const { dataSetId, versionId } = this.$route.query
      const hostFileId = rvtGroupInfo.hostFileId
      const groupIntId = rvtGroupInfo.groupIntId
      const params = {
        version: versionId,
        dataSetId,
        hostFileId: String(hostFileId),
        childNodeId: [groupIntId]
      }
      const response = await getBimElemIdsByGroupService(params)
      if (response.isSuccess) {
        const data = response.data
        const resId = dataSetId.replaceAll('-', '')
        const elemIds = data.childNodeIds.length
          ? data.childNodeIds
          : [this.elemInfo.elemId]
        highLightElems(resId, elemIds, false)
      } else {
        this.$message.error(response.errMsg)
      }
    },
    closeViewTreePanel() {
      this.isViewTreePanelVisible = false
      window.BlackHole3D.Graphics.setBtnActiveState('Catalog_Tree', 0)
    },
    closeAttributePanel() {
      this.isAttributePanelVisible = false
      this.elemInfo = {}
      this.attributeData = []
      window.BlackHole3D.Graphics.setBtnActiveState('Attribute', 0)
    },
    addCustomBtn() {
      let domRef = this.$refs.engine

      // 添加目录树按钮
      let treeLightImg = this.getImgPath('treeLight.png')
      let treeLightCheckImg = this.getImgPath('treeLightCheck.png')
      let treeStateList = []
      treeStateList.push({ hintText: '目录树', texPath: treeLightImg })
      treeStateList.push({ hintText: '目录树', texPath: treeLightCheckImg })
      domRef.addCustomBtn('Catalog_Tree', treeStateList, 1)

      // 添加属性按钮
      let attrLightImg = this.getImgPath('attrLight.png')
      let attrLightCheckImg = this.getImgPath('attrLightCheck.png')
      let attrStateList = []
      attrStateList.push({ hintText: '属性', texPath: attrLightImg })
      attrStateList.push({ hintText: '属性', texPath: attrLightCheckImg })
      domRef.addCustomBtn('Attribute', attrStateList, 0)
    },
    removeCustomBtn() {
      window.BlackHole3D.Graphics.delWidget('Catalog_Tree')
      window.BlackHole3D.Graphics.delWidget('Attribute')
    },
    async onCustomBtnClick(eventInfo) {
      let btnName = eventInfo.btnName
      let Graphics = window.BlackHole3D.Graphics
      let btnStatus = Graphics.getBtnActiveState(btnName)
      if (btnName.includes('Catalog_Tree')) {
        if (btnStatus === 1) {
          this.isViewTreePanelVisible = true
        } else {
          this.isViewTreePanelVisible = false
        }
      }

      if (btnName.includes('Attribute')) {
        if (btnStatus === 1) {
          this.isAttributePanelVisible = true
          window.BlackHole3D.Graphics.setBtnActiveState('Texture', 0)
          if (this.elemInfo) {
            if (this.isShowRvtGroup) {
              const rvtGroupInfo = await this.getRvtGroupInfo()
              const attributeData = await this.getRvtGroupAttr(rvtGroupInfo)
              this.attributeData = attributeData
            } else {
              this.queryBIMElemAttr()
            }
          }
        } else {
          this.isAttributePanelVisible = false
        }
      }
    },
    getDatasetResource() {
      return new Promise(resolve => {
        let { dataSetId, versionId } = this.$route.query

        let params = { dataSetIds: [dataSetId] }
        getDataSetResService(params).then(response => {
          if (response.isSuccess) {
            let dataSets = response.data

            dataSets.forEach(item => {
              item['assginVer'] = Number(versionId) - 1
            })
            resolve(dataSets)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    getImgPath(iconName) {
      let { origin, pathname } = window.location
      let iconPath = `${origin}${pathname.split('/index.html')[0]}`
      return `${iconPath}/engineIcon/${iconName}`
    },
    onUIThemeChange(eventInfo) {
      let themeName = eventInfo.themeName

      let Graphics = window.BlackHole3D.Graphics
      if (themeName.includes('Light')) {
        let treeLightImg = this.getImgPath('treeLight.png')
        let treeLightCheckImg = this.getImgPath('treeLightCheck.png')
        Graphics.setBtnStatePicPath('Catalog_Tree', 0, treeLightImg)
        Graphics.setBtnStatePicPath('Catalog_Tree', 1, treeLightCheckImg)
        Graphics.setSysPanelBtnClrStyle('Catalog_Tree', 0)

        let attrLightImg = this.getImgPath('attrLight.png')
        let attrLightCheckImg = this.getImgPath('attrLightCheck.png')
        Graphics.setBtnStatePicPath('Attribute', 0, attrLightImg)
        Graphics.setBtnStatePicPath('Attribute', 1, attrLightCheckImg)
        Graphics.setSysPanelBtnClrStyle('Attribute', 0)
      }

      if (themeName.includes('Dark')) {
        let treeDarkImg = this.getImgPath('treeDark.png')
        let treeDarkCheckImg = this.getImgPath('treeDarkCheck.png')
        Graphics.setBtnStatePicPath('Catalog_Tree', 0, treeDarkImg)
        Graphics.setBtnStatePicPath('Catalog_Tree', 1, treeDarkCheckImg)
        Graphics.setSysPanelBtnClrStyle('Catalog_Tree', 1)

        let attrDarkImg = this.getImgPath('attrDark.png')
        let attrDarkCheckImg = this.getImgPath('attrDarkCheck.png')
        Graphics.setBtnStatePicPath('Attribute', 0, attrDarkImg)
        Graphics.setBtnStatePicPath('Attribute', 1, attrDarkCheckImg)
        Graphics.setSysPanelBtnClrStyle('Attribute', 1)
      }
    },
    copyCanvas() {
      const canvasBox = document.getElementById('engineCanvas')
      if (canvasBox) {
        const canvasContainer = document.getElementById('canvas-container')
        canvasContainer.append(canvasBox)
      }
    },
    formatDataSetData(dataSets) {
      const formatType = dataSets[0]?.formatType
      let treeData = []
      if (formatType === 1) {
        treeData = dataSets[0].files
        treeData.forEach(item => {
          item['customNodeType'] = 'dataSet'
          item['formatType'] = formatType
          item['name'] = item.fileName
          item['dataSetId'] = dataSets[0].dataSetId
          item['dataSetType'] = dataSets[0].dataSetType
          item.nodes = [{ name: '' }]
        })
      }
      if (formatType === 2) {
        dataSets.forEach(item => {
          item['customNodeType'] = 'dataSet'
          item['name'] = item.dataSetName
          item.nodes = item.files
          item.nodes.forEach(node => {
            node['customNodeType'] = 'file'
            node['name'] = node.fileName
            node.nodes = [{ name: '' }]
          })
        })
        treeData = dataSets
      }
      return treeData
    }
  }
}
</script>

<style lang="less" scoped>
.version-view-box {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden;
  // margin-top: -16px;
  max-width: 100% !important;

  .engine-box {
    position: relative;
    flex-grow: 1;
    height: 100%;
    border-top: 1px solid var(--panel-border-color);
  }

  .version-tree-panel {
    top: 60px;
    left: 10px;
    width: 290px;
    min-width: 290px;
    height: calc(100% - 125px);

    :deep(.content) {
      display: flex;
      flex-direction: column;
      height: calc(100% - 40px);

      .common-tree-box {
        padding: 8px 10px;
        flex-grow: 1;
        min-height: 0;
        text-align: left;
      }

      .bottom-option-box {
        padding: 10px;
        text-align: left;
        border-top: 1px solid var(--dialog-split-line-color);

        .checkbox-primary {
          display: flex;
          align-items: center;
        }
      }
    }
  }
}
</style>
